import React from 'react';
import { FaTrashAlt, FaTruckMoving, FaRecycle, FaHome, FaBuilding, FaTv } from 'react-icons/fa';

const services = [
  {
    icon: <FaTrashAlt className="text-blue-500 text-4xl" />,
    title: 'Junk Removal',
    description: 'I\'ll remove unwanted items from your home or office quickly and efficiently.'
  },
  {
    icon: <FaTruckMoving className="text-blue-500 text-4xl" />,
    title: 'Moving Services',
    description: 'I\'ll help you move your belongings safely to a new location.'
  },
  {
    icon: <FaRecycle className="text-blue-500 text-4xl" />,
    title: 'Recycling Services',
    description: 'I offer eco-friendly recycling services to help you dispose of recyclable materials responsibly.'
  },
  {
    icon: <FaHome className="text-blue-500 text-4xl" />,
    title: 'Residential Cleanout',
    description: 'I provide thorough cleanout services for apartments, homes, and estates.'
  },
  {
    icon: <FaBuilding className="text-blue-500 text-4xl" />,
    title: 'Commercial Cleanout',
    description: 'I handle cleanouts for offices, retail spaces, and other commercial properties.'
  },
  {
    icon: <FaTv className="text-blue-500 text-4xl" />,
    title: 'Single Appliance Pickup',
    description: 'I will pick up a single appliance for a flat fee. Refrigerator, television, washers and dryers or any other appliances you need.'
  }
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-semibold text-black mb-6" data-aos="fade-down">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="p-6 bg-blue-100 rounded-md shadow-md text-center" data-aos="fade-up">
              <div className="mb-4">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-black mb-2">{service.title}</h3>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
